import { ChangeEvent, FormEvent, useState } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { WhiteContainer } from '../Login/styledComponents';
import { CustomButton, CustomInput, Text } from '../../shared/uiComponents';
import { errorNormalizer } from '../../shared/Helpers/functions';
import { DispatchProperties, useSelector } from '../../redux/store';
import { confirmAccount } from '../../redux/State/identitySlice/accountSlice';
import { Logo } from '../../components/Logo';

export const SetPasswordContent = () => {
	const loading = useSelector((state) => state.account.loading);

	const dispatch = useDispatch<DispatchProperties>();
	const navigate = useNavigate();
	const { search } = useLocation();

	const token = encodeURIComponent(new URLSearchParams(search).get('token') as string);
	const id = new URLSearchParams(search).get('userId') as string;

	const [showPassword, setShowPassword] = useState<boolean>(false);
	const [password, setPassword] = useState<string>('');
	const [confirmPassword, setConfirmPassword] = useState<string>('');

	const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		dispatch(
			confirmAccount({
				id,
				token,
				password,
				confirmPassword,
			}),
		)
			.then(unwrapResult)
			.then(() => {
				toast('Your password is updated');
				navigate('/login');
			})
			.catch(errorNormalizer);
	};

	const [confirmPasswordError, setConfirmPasswordError] = useState<string>('');

	const onPasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
		setConfirmPasswordError('');
		setPassword(event.target.value);
	};

	const onPasswordConfirmChange = (event: ChangeEvent<HTMLInputElement>) => {
		setConfirmPasswordError('');
		setConfirmPassword(event.target.value);
	};

	const onConfirmPasswordBlur = () => {
		setConfirmPasswordError(password === confirmPassword ? '' : 'Passwords do not match');
	};

	return (
		<WhiteContainer>
			<Text title="Set password" type="h4" font="header" fontWeight="semiBold" className="marginBottom24" />

			<form onSubmit={handleSubmit}>
				<CustomInput
					value={password}
					onChange={onPasswordChange}
					label="Password"
					className="marginBottom16"
					type={showPassword ? 'text' : 'password'}
					endAdornment={
						<FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} onClick={() => setShowPassword(!showPassword)} />
					}
				/>
				<CustomInput
					value={confirmPassword}
					onChange={onPasswordConfirmChange}
					onBlur={onConfirmPasswordBlur}
					label="Confirm Password"
					className="marginBottom16"
					type={showPassword ? 'text' : 'password'}
					error={Boolean(confirmPasswordError)}
					errorMessage={confirmPasswordError}
					endAdornment={
						<FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} onClick={() => setShowPassword(!showPassword)} />
					}
				/>
				<CustomButton
					title="Set password"
					type="submit"
					loading={loading}
					disabled={Boolean(confirmPasswordError) || !password || !confirmPassword}
				/>
			</form>
			<Logo />
		</WhiteContainer>
	);
};
